import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/PageHeader';
import { InboundQueuePanel } from './InboundQueuePanel';

/**
 * Die Anfrage-Queue als eigene Seite -- F5-03.
 *
 * **Sie steht nicht unter /administration und in keinem Menüpunkt.** Anfragen
 * zu sichten ist tägliche Arbeit und keine Einrichtung -- und gesucht wird
 * sie dort, wo jemand ohnehin arbeitet: Der Weg dorthin steht in der
 * Ticketliste, oben rechts neben „Kanban-Board" und „Neues Ticket", mit einer
 * Blase, sobald etwas wartet. Ein eigener Eintrag in der Seitenleiste wäre
 * eine Zeile mehr, die man an den meisten Tagen vergeblich anklickt.
 *
 * Entsprechend trägt die Seite ``mail.triage`` und nicht ``mail.manage``: Die
 * Rolle „Bearbeitung" kommt hier heran, an die Postfachkennwörter daneben
 * aber nicht.
 *
 * Dieselbe Liste steht zusätzlich als Reiter in der E-Mail-Anbindung -- wer
 * dort ein Postfach einrichtet, sucht sie in diesem Zusammenhang.
 */
export function InboundQueuePage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('inbound.title')} subtitle={t('inbound.hint')} />

      <InboundQueuePanel heading={false} />
    </>
  );
}
